

import { useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useSitePolicy } from "../hooks/useSitePolicy";
import aboutImg from "../images/aboutCouple.png";
import aboutGradArrow from "../images/aboutGradArrow.png";

const AboutLayout = ({ children }) => {
  const { data } = useSitePolicy();

  useEffect(() => {
    if (!data?.about_us) return;

    const headings = [
      "Welcome to IND Matrimony",
      "Our Vision",
      "Why Choose Us?",
      "How It Works",
      "Join the IND Matrimony Family",
    ];

    const containers = document.querySelectorAll(".about-content");

    if (!containers.length) return;

    containers.forEach((container) => {
      const strongTags = container.querySelectorAll("p strong");

      strongTags.forEach((el) => {
        if (headings.includes(el.textContent.trim())) {
          // Apply red color only
          el.style.color = "rgba(230, 0, 0, 0.81)";
          el.style.display = "inline-flex";
          el.style.alignItems = "center";
          el.style.gap = "6px";

          // Prevent duplicate arrow
          if (!el.querySelector("img")) {
            const img = document.createElement("img");
            img.src = aboutGradArrow;
            img.style.width = "14px";
            img.style.height = "14px";
            img.style.marginRight = "6px";

            el.prepend(img);
          }
        }
      });
    });
  }, [data]);

  return (
    <>
      <Navbar />

      <Box
        sx={{
          background: "#fbfaf9",
          pt: 12,
          pb: 10,
        }}
      >
        <Container maxWidth="lg">
            {children}
          

          {/* IMAGE + TOP CONTENT */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 6,
              alignItems: "flex-start",
            }}
          >
            {/* LEFT IMAGE */}
            <Box
              sx={{
                flex: "0 0 45%",
                textAlign: "center",
              }}
            >
              <img
                src={aboutImg}
                alt="About"
                style={{
                  width: "100%",
                  maxWidth: 420,
                }}
              />
            </Box>

            {/* RIGHT CONTENT (TOP PART) */}
            <Box
              className="about-content"
              sx={{
                flex: 1,
                "& p": {
                  fontSize: "14px",
                  lineHeight: 1.8,
                  color: "#333",
                  mb: 1,
                  textAlign: "left",
                },
              }}
              dangerouslySetInnerHTML={{
                __html:
                  data?.about_us?.split("</p>").slice(0, 8).join("</p>") +
                    "</p>" || "",
              }}
            />
          </Box>

          {/* REMAINING CONTENT FULL WIDTH */}
          <Box
            className="about-content"
            sx={{
              mt: 6,
              "& p": {
                fontSize: "14px",
                lineHeight: 1.8,
                color: "#333",
                mb: 2,
                textAlign: "left",
              },
            }}
            dangerouslySetInnerHTML={{
              __html:
                data?.about_us?.split("</p>").slice(8).join("</p>") || "",
            }}
          />
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default AboutLayout;
